import { Button } from "./button";
import { beerEmoji, puppyEmoji } from "./constants";

export const Intro = ({ setCurrentStep }: { setCurrentStep: (step: 'beer' | 'puppy' | 'result') => void }) => {
  return (
    <div className="step-container">
      <div className="content-card">
        <h1>2 Beers {beerEmoji} and a Puppy {puppyEmoji}</h1>
        <div className="intro-text">
          <p>Based on <a href="https://www.rossmccammon.com/2-beers-and-a-puppy">Two beers and a puppy</a> by Ross McCammon.</p>
          <p>In his book, Works Well With Others, he mentions a test that he developed while working on a story. It's a quick way to gain clarity of how you feel about someone.</p>
          <p>Would you like to work out how you feel about someone?</p>
        </div>
        <Button className="primary-button" onClick={() => setCurrentStep('beer')} label="How do I feel?" />
      </div>
    </div>
  );
}
